import BaseApi from "../../../services/baseApi";

class ExcelFile_se {
    constructor() {
        this.entity = 'smsByManager';
    }


    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    getTemplate(buildingId) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/getTemplate/?buildingId='+buildingId,
            headers: {'Content-Type': 'application/json'},
        })
    }

    save(file , template,buildingId) {
        let formData = new FormData();
        formData.set("file",file)
        formData.set("id", template)
        formData.set("buildingId", buildingId)
        // formData.set("template", template)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/smsByManager/',
            headers: {'Content-Type': 'application/json'},
        })
    }




}
export default new ExcelFile_se();
